import { render, staticRenderFns } from "./archive-procedure.vue?vue&type=template&id=1ef72cf8&"
import script from "./archive-procedure.vue?vue&type=script&lang=js&"
export * from "./archive-procedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports